import { publicClient, privateClient } from "../../configs/axiosConfig";

const serviceEndpoints = {
  getallService: "v2/services",
  getallServicePublic: `v2/services/getpublicnail?key=${process.env.REACT_APP_REMINDER_CRON_SECRET}`,
  getServiceDetail: "v2/services/:id",
  getServiceCategory: "v2/services/getServiceCategory",
};

const sericesApi = {
  getallService: async ({ operatorId }) => {
    try {
      const response = await privateClient.get(
        `${serviceEndpoints.getallService}?operatorId=${operatorId}`
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  getallServicePublic: async () => {
    try {
      const response = await publicClient.get(
        serviceEndpoints.getallServicePublic
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  getServiceDetail: async ({ nailId }) => {
    try {
      const response = await privateClient.get(
        serviceEndpoints.getServiceDetail,
        {
          nailId,
        }
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  getServiceCategory: async ({ operator }) => {
    try {
      const response = await privateClient.post(
        serviceEndpoints.getServiceCategory,
        { operator }
      );
      return response.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Get operator failed");
    }
  },
};

export default sericesApi;
